import { ENTITY_CLASS } from "@packages/core";
import { useQuery } from "@tanstack/react-query";
import { Temporal } from "temporal-polyfill";

import { fetchData } from "./functions";
import { QueryKey } from "./query";
import { TANSTACK_QUERY_CLIENT } from "./tanstack";

export async function findApplicationConfiguration() {
  const { output } = await fetchData({ type: "Entity::ApplicationConfiguration" });
  if (output instanceof Error) {
    throw output;
  } else {
    return output;
  }
}

function ApplicationConfigurationQueryKey() {
  return QueryKey(ENTITY_CLASS.APPLICATION_CONFIGURATION);
}

export function updateApplicationConfigurationQueryData(
  newApplicationConfiguration: ReturnType<typeof useApplicationConfigurationQuery>["data"] | false,
) {
  if (newApplicationConfiguration !== false && newApplicationConfiguration !== undefined) {
    TANSTACK_QUERY_CLIENT.setQueryData(
      ApplicationConfigurationQueryKey(),
      function (
        oldApplicationConfiguration: ReturnType<typeof useApplicationConfigurationQuery>["data"],
      ) {
        return !oldApplicationConfiguration ||
          !newApplicationConfiguration ||
          (Temporal.PlainDateTime.compare(
            oldApplicationConfiguration.createdAt,
            newApplicationConfiguration.createdAt,
          ) ||
            Temporal.PlainDateTime.compare(
              oldApplicationConfiguration.updatedAt,
              newApplicationConfiguration.updatedAt,
            )) < 0
          ? newApplicationConfiguration
          : oldApplicationConfiguration;
      },
    );
  }
}

export function useApplicationConfigurationQuery() {
  return useQuery({
    queryKey: ApplicationConfigurationQueryKey(),
    async queryFn() {
      return findApplicationConfiguration();
    },

    refetchInterval: /** 8時間 */ 28_800_000, // 一定間隔で再取得を強制する。
    refetchIntervalInBackground: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: /** 4時間 */ 14_400_000,
  });
}
